import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueSituacaoFinanceira, TSituacaoFinanceira } from "../../types/api/financeiro/situacao-financeira";

export default function SelectSituacaoFinanceira({
    value,
    onChange,
    required = false,
    error = false,
    multiple = false,
    possuiBtnLimpar = false,
    extraParams = {}
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = (() => {
        if (!value) return "";
        if (Array.isArray(value)) {
            return value.map(item => item.id).join(", ");
        } else {
            return `${value.id ?? ''}${value.nome ? ` - ${value.nome}` : ''}`;
        }
    })();

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Situação`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                slotProps={{
                    input: { readOnly: true }
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, multiple, possuiBtnLimpar, extraParams }}
                        title="Selecionar situação"
                        queryPath="/financeiro/contas-receber/pesquisar-situacoes"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        defaultValue={multiple
                            ? (Array.isArray(value) && value.length > 0 ? value : [defValueSituacaoFinanceira])
                            : (value ? value : defValueSituacaoFinanceira)}
                        onChange={(value) => {
                            onChange(value as TSituacaoFinanceira)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TSituacaoFinanceira
    onChange: (arg: TSituacaoFinanceira | null) => void
    required?: boolean
    error?: boolean
    multiple?: boolean
    possuiBtnLimpar?: boolean
    extraParams?: { [key: string]: any };
}